export default __webpack_public_path__ + "static/interaction-405a4db4c5ffaf1b39b26828e5ca289b.png";